import React from 'react'
import { Tooltip } from 'react-mdl'
import './style.css'

// Constants.
import Quality from './quality'
import RuneNames from './rune-names'

// Components.
import MagicAttribute from './magic-attribute'
import SocketedItem from './socketed-item'
import DisplayCalculator from './display-calculator'
import RareAffixes from './rare-affixes'

export default class Item extends React.Component {

    constructor(props) {
        super(props);

        // We'll be merging the item attributes in the constructor, because
        // we want to use them through out this component, without having to
        // loop over them more than once.
        var attributes = [];

        // This is one mother fucker of a problem, if we don't dereference the item
        // by making it into a string, and then parsing it back into an object,
        // the merger will mutate the original items magic attributes, due to javascript
        // sending everything as a reference, no matter how many times we clone it or
        // assign it to another variable, javascript will still have a pointer to it,
        // and mutate it, thus ruining our lives.
        var clone = (JSON.parse(JSON.stringify(props.data)));

        if (clone.magic_attributes !== undefined) {
            // Merger.merge(attributes, clone.magic_attributes);
            attributes = clone.magic_attributes;
        }

        this.state = {
            item: props.data,
            activeWeaponTabId: props.activeWeaponTabId,
            mergedAttributes: attributes
        };
    }

    handleSwitchWeapons(activeWeaponTabId) {
        this.setState({ activeWeaponTabId: activeWeaponTabId });
    }

    getTitle() {
        let fullItemName = this.state.item.full_item_name;
        let prefixClass = null;

        if (this.state.item.runeword) {
            prefixClass = "runeword";
        }
        else if (this.state.item.pre_item) {
            prefixClass = "pre-item";
        }
        else {
            prefixClass = this.state.item.quality;
        }
        if (this.state.item.ear_attributes !== undefined) {
            fullItemName = `${this.state.item.ear_attributes.name}'s ${this.state.item.type_name}`
        }

        return (
            <div>
                { (this.state.item.ear_attributes === undefined) ? <p>Item level: {this.state.item.ilvl}</p> : null }
                
                { (this.state.item.personalized) ?
                    <h3 className={`type-${this.state.item.quality}`}>{this.state.item.personalized_name}'s</h3>
                    :
                    null
                }
                
                <h3 className={`type-${prefixClass}`}>{fullItemName}</h3>

                { (this.state.item.quality !== Quality.magicallyEnhanced) && this.state.item.ear_attributes === undefined 
                    && !(this.state.item.type === "toa" || this.state.item.type === "eoh" || this.state.item.type === "eoa" || this.state.item.type === "eot" || this.state.item.type === "eop") ?
                    <h3 className={`type-${this.state.item.quality}`}>{this.state.item.type_name}</h3>
                    :
                    null
                }

                { (this.state.item.ear_attributes !== undefined) ?
                    <div>
                        <h3 className={`type-${this.state.item.quality}`}>{this.state.item.ear_attributes.class}</h3>
                        <h3 className={`type-${this.state.item.quality}`}>Level: {this.state.item.ear_attributes.level}</h3>
                    </div>
                    :
                    null
                }
            </div>
        );
    }

    getStandardAttributes() {

        // Check for enhancers that will alter the defense or weapon
        var enhancers = DisplayCalculator.calculate(this.state.mergedAttributes);
        let setPartialBonuses;
        if (this.state.activeWeaponTabId === undefined) {
            setPartialBonuses = this.state.item.setPartialBonuses;
        } else {
            setPartialBonuses = this.state.item.setPartialBonuses[this.state.activeWeaponTabId];
        }
        if (setPartialBonuses !== undefined) {
            DisplayCalculator.calculateAttributes(setPartialBonuses, enhancers);
        }

        var defense = null;
        var defenseIncreased = false;
        if (this.state.item.defense_rating !== undefined) {
            var defenseRating = Math.floor(this.state.item.defense_rating * (1 + (enhancers.enhancedDefense/100)) + enhancers.flatDefense);
            defenseIncreased = defenseRating > this.state.item.defense_rating;
            defense = `${defenseRating}`;
        }

        var weaponDamage = null;
        var twoHandWeaponDamage = null;
        var throwWeaponDamage = null;
        if (this.state.item.damage !== undefined) {
            // Throw weapon damage.
            if (this.state.item.damage.throw_min !== undefined) {
                throwWeaponDamage = `${this.state.item.damage.throw_min} to ${this.state.item.damage.throw_max}`;
            }

            // One hand weapon damage.
            if (this.state.item.damage.one_hand_min !== undefined) {
                weaponDamage = `${this.state.item.damage.one_hand_min} to ${this.state.item.damage.one_hand_max}`;
            }

            // Two hand weapon damage.
            if (this.state.item.damage.two_hand_min !== undefined) {
                twoHandWeaponDamage = `${this.state.item.damage.two_hand_min} to ${this.state.item.damage.two_hand_max}`;
            }
        }

        var durability = null;
        var durabilityIncreased = false;
        if (this.state.item.max_durability !== undefined && this.state.item.max_durability > 0) {
            var maxDurability = Math.floor(this.state.item.max_durability * (1 + (enhancers.enhancedDurability/100)) + enhancers.flatDurability);
            durabilityIncreased = maxDurability > this.state.item.max_durability;
            durability = `${this.state.item.current_durability} of ${maxDurability}`;
        }

        var quantity = null;
        if (this.state.item.quantity !== undefined) {
            quantity = `Quantity: ${this.state.item.quantity}`;
        }

        return (
            <div>
                { (defense !== null) ?
                    <p>Defense: <span className={'increased-' + defenseIncreased}>{defense}</span></p>
                    :
                    null
                }

                { (throwWeaponDamage !== null) ?
                    <p>Throw damage: <span className={'increased-' + this.state.item.damage.throw_damage_enhanced}>{throwWeaponDamage}</span></p>
                    :
                    null
                }

                { (weaponDamage !== null) ?
                    <p>One-hand damage: <span className={'increased-' + this.state.item.damage.one_hand_damage_enhanced}>{weaponDamage}</span></p>
                    :
                    null
                }

                { (twoHandWeaponDamage !== null) ?
                    <p>Two-hand damage: <span className={'increased-' + this.state.item.damage.two_hand_damage_enhanced}>{twoHandWeaponDamage}</span></p>
                    :
                    null
                }

                { (durability !== null) ?
                    <p>Durability: <span className={'increased-'+durabilityIncreased}>{durability}</span></p>
                    :
                    null
                }
                <p>{quantity}</p>
            </div>
        );
    }

    getMagicAttributes() {

        return (
            <div>
            { (this.state.mergedAttributes.length > 0) ?
                this.state.mergedAttributes.map((props, i) =>
                    <MagicAttribute key={`${this.state.item.id}-socketed-${props.id}-${i}`} data={props}/>
                )
                :
                null
            }
            </div>
        );
    }

    getRareAffixes() {
        let prefixes = [];
        if (this.state.item.prefixes !== undefined) {
            prefixes = this.state.item.prefixes;
        }
        let suffixes = [];
        if (this.state.item.suffixes !== undefined) {
            suffixes = this.state.item.suffixes;
        }

        return (
            <div>
            { (prefixes.length > 0 || suffixes.length > 0) ?
                <RareAffixes key={this.state.item.id} prefixes={prefixes} suffixes={suffixes}/>
                :
                null
            }
            </div>
        );

    }

    getSetPartialAttributes() {
        let setPartialBonuses;
        if (this.state.activeWeaponTabId === undefined) {
            setPartialBonuses = this.state.item.setPartialBonuses;
        } else {
            setPartialBonuses = this.state.item.setPartialBonuses[this.state.activeWeaponTabId];
        }
        if (setPartialBonuses === undefined) {
            return null;
        }

        var attributes = [];
        if (setPartialBonuses.length > 0) {
            setPartialBonuses.map(function(attribute) {
                return attributes.push(attribute);
            });
        }

        return (
            <div>
            { (attributes.length > 0) ?
                attributes.map((props, i) =>
                    <div key={`${this.state.item.id}-set-wrap-${props.id}-${i}`} className="set-partial-property">
                        <MagicAttribute key={`${this.state.item.id}-set-${props.id}-${i}`} data={props}/>
                    </div>
                )
                :
                null
            }
            </div>
        );
    }

    getSetAttributes() {
        let setBonuses;
        if (this.state.activeWeaponTabId === undefined) {
            setBonuses = this.state.item.setBonuses;
        } else {
            setBonuses = this.state.item.setBonuses[this.state.activeWeaponTabId];
        }

        if (setBonuses === undefined) {
            return null;
        }

        var attributes = [];
        if (setBonuses.length > 0) {
            setBonuses.map(function(attribute) {
                return attributes.push(attribute);
            });
        }

        return (
            <div className="set-bonuses">
            { (attributes.length > 0) ?
                attributes.map((props, i) =>
                    <div key={`${this.state.item.id}-set-wrap-${props.id}-${i}`} className="set-property">
                        <MagicAttribute key={`${this.state.item.id}-set-${props.id}-${i}`} data={props}/>
                    </div>
                )
                :
                null
            }
            </div>
        );
    }

    getSetInfo() {
        if (this.state.item.setInfo === undefined) {
            return null;
        }
        return (
            <div className="set-info">
                <h3 className="set-name">{this.state.item.setInfo.name}</h3>
                <div className="set-items-info">
                {
                    this.state.item.setInfo.items.map((item) =>
                        <h3 className={`possessed-${item.possessed}`}>{item.name}</h3>
                    )
                }
                </div>
            </div>
        );
    }

    getNrOfSockets() {
        var socketed = null;
        if(this.state.item.socketed) {
            socketed = `Socketed (${this.state.item.total_nr_of_sockets})`;
        }

        return (
            <div>
                <p className="magic-property">{socketed}</p>
            </div>
        );
    }

    getEthereal() {
        var ethereal = null;
        if(this.state.item.ethereal) {
            ethereal = "Ethereal (Cannot be repaired)";
        }

        return (
            <div>
                <p className="magic-property">{ethereal}</p>
            </div>
        );
    }

    getUnidentified() {
        var unid = null;

        if(!this.state.item.identified) {
            unid = "(Unidentified)";
        }

        return (
            <div>
                <p className="unidentified">{unid}</p>
            </div>
        );
    }

    getItemImage() {
        var itemImage = null;
        if(this.state.item.multiple_pictures) {

            // If it's annihilus or hellfire torch, we'll display their images instead.
            if(this.state.item.quality === Quality.unique && (this.state.item.type === "cm1" || this.state.item.type === "cm2")) {
                itemImage = `u${this.state.item.unique_id}`;
            }
            else {
                itemImage = this.state.item.type + "_" + this.state.item.picture_id;
            }

        } else {
            if (this.state.item.quality === Quality.unique && !(this.state.item.type === "toa" || this.state.item.type === "eoh" || this.state.item.type === "eoa" || this.state.item.type === "eot" || this.state.item.type === "eop")) {
                itemImage = `u${this.state.item.unique_id}`;
            }
            else if(this.state.item.quality === Quality.set) {
                itemImage = `s${this.state.item.item_set_id}`;
            }
            else {
                itemImage = this.state.item.type.toLowerCase();
            }
        }

        return itemImage;
    }

    getRuneNames() {
        var names = "";
        if(this.state.item.nr_of_items_in_sockets > 0) {
            this.state.item.socketed_items.map(function(item) {
                var match = item.type.match(/r[0-9]/g);
                if (match !== null) {
                    names += RuneNames[item.type];
                }
                return true;
            });
        }

        if(names.length > 0) {
            return (
                <h3 className="type-runeword">{names}</h3>
            );
        }

        return null;
    }

    renderTooltip() {

        let title = this.getTitle();
        let runeNames = this.getRuneNames();
        let standardAttributes = this.getStandardAttributes();
        let magicAttributes = this.getMagicAttributes();
        let setPartialAttributes = this.getSetPartialAttributes();
        let setAttributes = this.getSetAttributes();
        let setInfo = this.getSetInfo();
        let nrOfSockets = this.getNrOfSockets();
        let ethereal = this.getEthereal();
        let isUnidentified = this.getUnidentified();
        let affixes = this.getRareAffixes();

        return (
            <div>
                {title}
                {runeNames}
                {standardAttributes}
                {magicAttributes}
                {nrOfSockets}
                {ethereal}
                {isUnidentified}
                {setPartialAttributes}
                {setAttributes}
                {setInfo}
                {affixes}
            </div>
        );
    }

    render() {
        let item = this.state.item;
        let tooltip = this.renderTooltip();

        let locationClass = "";
        // If the item is equipped, we'll add the id to the class names.
        if(item.location_id === 1) {
            locationClass = `location-${item.equipped_id}`;
        }
        else {
            locationClass = 'inv-item';
        }

        let itemImage = this.getItemImage();

        return (
            <Tooltip position="left" className="item-tooltip" label={tooltip}>
                <div className={`item ${locationClass} quality-${item.quality} pos-x-${item.x} pos-y-${item.y}`}>
                    <span className="helper"></span>
                    <div className={`item-image`}>
                        <img className={`ethereal-${item.ethereal}`} src={`${process.env.PUBLIC_URL}/assets/items/${itemImage}.png`} role="presentation"/>
                        { (item.nr_of_items_in_sockets > 0) ?
                                <div className={`socketed-items sockets-${item.nr_of_items_in_sockets}`}>
                                {item.socketed_items.map((socketedItem, i) =>
                                    <SocketedItem key={`${item.id}_${i}}`} data={{item: socketedItem, position: i}}/>
                                )}
                                </div>
                            :
                            null
                        }

                    </div>
                </div>
            </Tooltip>
        );
    }
};



// WEBPACK FOOTER //
// ./src/components/character/item/index.js